import { render, staticRenderFns } from "./BlockVideoLeftTextRight.vue?vue&type=template&id=7b31fefd&"
import script from "./BlockVideoLeftTextRight.vue?vue&type=script&lang=js&"
export * from "./BlockVideoLeftTextRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports